import React, { useState } from 'react';
import { UserPlus } from 'lucide-react';
import { actionApi } from './drGActions';
import { ConfirmShell, useConfirm, SendMessageCard } from './SendMessageCard';
import { LookupCard } from './LookupCard';

const FIELDS = [['firstName', 'First name'], ['lastName', 'Last name'], ['specialty', 'Specialty'], ['email', 'Email (required)'],
  ['phone', 'Phone'], ['address', 'Address'], ['website', 'Website']];

const SaveDentistCard = ({ action, doneKey }) => {
  const [f, setF] = useState(() => Object.fromEntries(FIELDS.map(([k]) => [k, action[k] || ''])));
  const c = useConfirm(doneKey, () => {
    const missing = ['firstName', 'lastName', 'specialty', 'email'].filter((k) => !f[k].trim());
    if (missing.length) throw new Error(`Please fill in: ${missing.join(', ')}`);
    return actionApi.saveDentist(Object.fromEntries(Object.entries(f).map(([k, v]) => [k, v.trim() || null])));
  });
  return (
    <ConfirmShell title="Save to Referral Dentists" icon={<UserPlus className="w-4 h-4 text-sky-600" />} testid="dr-g-save-dentist-card" {...c} onConfirm={c.confirm} onCancel={c.cancel}>
      <div className="grid grid-cols-2 gap-2">
        {FIELDS.map(([k, label]) => (
          <input key={k} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} placeholder={label} title={label}
            data-testid={`dr-g-dentist-${k}`}
            className={`rounded-lg border px-2.5 py-1.5 text-sm ${['address', 'website'].includes(k) ? 'col-span-2' : ''} ${k === 'email' && !f.email ? 'border-amber-300' : 'border-slate-200'}`} />
        ))}
      </div>
    </ConfirmShell>
  );
};

export const ActionCard = ({ action, doneKey }) => {
  if (action.type === 'lookup_patient') return <LookupCard action={action} />;
  if (action.type === 'send_message') return <SendMessageCard action={action} doneKey={doneKey} />;
  if (action.type === 'save_referral_dentist') return <SaveDentistCard action={action} doneKey={doneKey} />;
  return null;
};
